import React from 'react';
import {Link} from 'react-router-dom';
import * as ROUTES from './constants/routes';

interface PropsType{
	isLoggedIn:boolean
}

export default class Navigation extends React.Component<PropsType>{
	
	constructor(props:PropsType){
		super(props);
	}

	render(){
		return(
			<div id='teachers-navigation'>
				<Link to={ROUTES.CONTENT}><button className='teachers-button teachers-button-default'>Content</button></Link>
				
				<Link to={ROUTES.TASKS}>
					<button className='teachers-button teachers-button-default' 
						disabled={!this.props.isLoggedIn}
						>Homework Tasks</button>
				</Link>

				<Link to={ROUTES.EMBED}><button className='teachers-button teachers-button-default'>Embed</button></Link>
				<Link to={ROUTES.GETLINK}><button className='teachers-button teachers-button-default'>Links</button></Link>
			</div>
		)
	}
};

